import { isNonEmptyArray } from '@/helpers/array-helpers'
import TimesheetResultModel from './timesheetResultModel'

export default class TimesheetSubmitResponseViewModel {
  constructor({
    approvedForInvoiceCount = 0,
    pendingReviewCount = 0,
    errors = [],
  } = {}) {
    /**
     * @type {Number}
     */
    this.approvedForInvoiceCount = approvedForInvoiceCount

    /**
     * @type {Number}
     */
    this.pendingReviewCount = pendingReviewCount

    /**
     * @type {Array<TimesheetResultModel>}
     */
    this.errors = isNonEmptyArray(errors)
      ? errors.map(
          (pendingApproval) => new TimesheetResultModel(pendingApproval)
        )
      : []
  }
}
